import { useEffect, useState } from 'react';
import './NavBar.css';
import ScrollOffsetLink from '../Common/ScrollToOffsetLink/ScrollToOffsetLink';
import PageMessageBanner from './PageMessageBanner/PageMessageBanner';

interface NavBarProps {
    setShowMessageBanner: React.Dispatch<React.SetStateAction<boolean>>
    showMessageBanner: boolean
}

function NavBar({setShowMessageBanner, showMessageBanner}: NavBarProps) {

    const [scrolled, setScrolled] = useState(window.scrollY !== 0)
    const scrollOffset = -150
    const [currentSection, setCurrentSection] = useState('home-section')

    function handleScroll() {
        const sectionEls = document.querySelectorAll(".scrollable-section") as NodeListOf<HTMLElement>
        sectionEls.forEach(sectionEl => {
            if(window.scrollY >= sectionEl.offsetTop - 275){
                setCurrentSection(sectionEl.id)
                const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
                const documentHeight = Math.max(
                    document.body.scrollHeight || 0,
                    document.documentElement.scrollHeight || 0
                );
                const threshold = 10;
                if (window.scrollY + windowHeight >= documentHeight - threshold){
                    setCurrentSection("contact-section")
                }
                if(window.scrollY > 200){
                    setScrolled(true)
                }else{
                    setScrolled(false)
                }
            }
        })
    }

    useEffect(()=> {
        window.addEventListener("scroll", handleScroll)

        return () => {
            window.removeEventListener("scroll", handleScroll)
        }
    }, [])


    function clearCurrent() {
        let list = document.getElementById("navlist")
        let items = list?.getElementsByTagName("li")
        for (var i = 0; i < items!.length; ++i) {
            if (items![i].classList.contains("current")) {
                items![i].classList.remove("current")
                break
            }
        }
    }

    useEffect(()=> {
        let list = document.getElementById("navlist")
        let items = list?.getElementsByTagName("a")
        for (var i = 0; i < items!.length; ++i) {
            if (items![i].getAttribute("href") === `#${currentSection}`) {
                clearCurrent()
                items![i].parentElement?.classList.add("current")
                break
            }
        }
    },[currentSection])



    return (
        <div className='navbar-container'>
            {showMessageBanner && <PageMessageBanner setShowMessageBanner={setShowMessageBanner}/>}
            <nav id="navbar" className={scrolled ? "navbar-scrolled" : ''}>
                <div id="logo-container">
                    <img src='logo192.png' alt='Trisha Somers Coaching Logo'/>
                </div>
                <ul id="navlist">
                    <li className='current'><ScrollOffsetLink offset={scrollOffset} href="#home-section">HOME</ScrollOffsetLink></li>
                    <li><ScrollOffsetLink offset={scrollOffset} href="#offerings-section">OFFERINGS</ScrollOffsetLink></li>
                    <li><ScrollOffsetLink offset={scrollOffset} href="#about-section">ABOUT</ScrollOffsetLink></li>
                    <li><ScrollOffsetLink offset={scrollOffset} href="#testimonials-section">TESTIMONIALS</ScrollOffsetLink></li>
                    <li><ScrollOffsetLink offset={scrollOffset} href="#contact-section">CONTACT</ScrollOffsetLink></li>
                </ul>
            </nav>
        </div>
    );
}

export default NavBar;